import { ConfigOptions, MainMenu, SortingConfig } from 'rangeConfig/@types';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import {
  hingedDoorsProductListConfig,
  slidingDoorsCustomProductListConfig,
  slidingDoorsDesktopProductListConfig,
  slidingDoorsMobileProductListConfig
} from './productListConfig';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import { colorFilter, doorsTypeFilter } from 'rangeConfig/pax/filters/configFilters';
import platform from 'rangeConfig/shared/utils/platform';
import ProductSortFilterWidget from 'rangeConfig/shared/widgets/ProductSortFilterWidget';
import SlidingDoorsInfoMessageMobileSwiper from 'components/ProductSidebar/CategoryWidget/SlidingDoorsInfoMessageMobileSwiper';
import {
  framesInSceneSupportSlidingDoors,
  hidePaxCornerFrameOpenCombinationErrorMessage
} from 'rangeConfig/pax/rules/hideMenuRules';
import withErrorMessage from 'rangeConfig/shared/widgets/withErrorMessage';
import {
  getNoFramesInSceneErrorMessage,
  getPaxCornerFrameOpenCombinationErrorMessage
} from 'rangeConfig/shared/utils/errorMessages';
import ErrorMessageInline from 'rangeConfig/shared/widgets/ErrorMessageInline';
import { CoreApi } from '@inter-ikea-storageone/range';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';
import {
  sortByPriceAscending,
  sortByPriceDescending,
  sortByName
} from 'rangeConfig/shared/sorting/sortingConfigs';

const widgets = {
  desktop: [
    {
      id: 'error-message-no-frames-in-scene',
      component: withErrorMessage(getNoFramesInSceneErrorMessage)(ErrorMessageInline),
      hidden: (coreApi: CoreApi) => hideNoFramesInSceneErrorMessage(coreApi)
    },
    {
      id: 'error-message-corner-frame-open-combination',
      component: withErrorMessage(getPaxCornerFrameOpenCombinationErrorMessage)(ErrorMessageInline),
      hidden: (coreApi: CoreApi) => hidePaxCornerFrameOpenCombinationErrorMessage(coreApi)
    },
    {
      id: 'doors-sort-filter-widget',
      component: ProductSortFilterWidget
    },
    {
      id: 'hinged-doors-product-list',
      component: withProducts(ProductList, hingedDoorsProductListConfig)
    },
    {
      id: 'custom-sliding-door',
      component: withProducts(ProductList, slidingDoorsCustomProductListConfig)
    },
    {
      id: 'sliding-doors-product-list',
      component: withProducts(ProductList, slidingDoorsDesktopProductListConfig)
    }
  ],
  mobile: [
    {
      id: 'hinge-doors-product-list',
      component: withProducts(ProductSwiper, hingedDoorsProductListConfig),
      title: 'storageone.doorCategoryTitleHingedDoors'
    },
    {
      id: 'sliding-doors-product-list',
      component: withProducts(ProductSwiper, slidingDoorsMobileProductListConfig),
      title: 'storageone.doorCategoryTitleSlidingDoors'
    },
    {
      id: 'custom-sliding-doors-product-list',
      component: withProducts(ProductSwiper, slidingDoorsCustomProductListConfig),
      title: 'storageone.mobileTabCustomSlidingDoors'
    },
    {
      id: 'sliding-door-info-message',
      component: SlidingDoorsInfoMessageMobileSwiper,
      title: 'storageone.doorCategoryTitleSlidingDoors',
      hidden: framesInSceneSupportSlidingDoors
    }
  ]
};

const filters = {
  desktop: [doorsTypeFilter, colorFilter],
  mobile: [colorFilter]
};

const sorting = (_options?: ConfigOptions) =>
  [sortByName, sortByPriceAscending, sortByPriceDescending].filter(Boolean) as SortingConfig[];

const mainMenu = (options?: ConfigOptions): MainMenu => ({
  menuTitle: 'storageone.productListDoorsTitle',
  behaviors: {
    productGroupEntered: [showDoors],
    productGroupExited: []
  },
  filters: filters[platform],
  sorting: sorting(options),
  widgets: widgets[platform]
});

export default mainMenu;
